import { FormikProvider, Formik, useFormik } from "formik";
import React, { useEffect, useState, useRef } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useIntl } from "react-intl";
import AutocompleteV2 from "../../component/AutocompleteObjectV2";
import LabelRequired from "../../component/LabelRequired";
import TextField from "../../component/TextField";
import { IService } from "../models/ServiceModels";
import { addDV } from "../services/services";
import { CODE, KEY } from '../../utils/Constant';

type Props = {
  handleClose: (isBackHomePage?: boolean) => void;
  data: any;
  handleReload: () => Promise<void>;
};

const ServiceDetailDialog = (props: Props) => {
  const { handleClose, data, handleReload } = props;
  const [initialValues, setInitialValues] = React.useState<IService>({
    id: "",
    code: "",
    name: "",
    description: ""
  });
  const intl = useIntl();
  const formRef = useRef<any>(null);
  const validationSchema = Yup.object({});

  useEffect(() => {
    if (data?.id) {
      formRef?.current?.setValues(data);
    } else {
      formRef?.current?.resetForm();
    }
  }, [data]);

  const handleSubmit = async (values: IService) => {
    let _values = {
      ...values,
    };

    try {
      const res = await addDV(_values);
      console.log(res);
      
      if (res?.data?.code === CODE.SUCCESS) {
        toast.success(
          data?.id
            ? intl.formatMessage({ id: "TOAST.EDIT.SUCCESS" })
            : intl.formatMessage({ id: "TOAST.CREATE.SUCCESS" })
        );
        // handleReload();
        handleClose();
      } else {
        toast.error(`${res?.data?.message}`);
      }
    } catch (err) {
      console.log(err);
      
      toast.error(intl.formatMessage({ id: "GENERAL.ERROR" }));
    }
  };

  const formik = useFormik({
    initialValues: data?.id ? data : initialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });

  return (
    <Modal show={true} centered onHide={() => handleClose(false)} size="xl">
      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit}>
          <Modal.Header closeButton className="header-modal">
            <Modal.Title className="text-pri ">Thông tin dịch vụ</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-3">
              <Col lg={4}>
                <TextField
                  label={<LabelRequired isRequired label="Mã dịch vụ" />}
                  name={"code"}
                  type={"text"}
                  value={formik?.values?.code}
                  disabled={data?.id ? true : false}
                />
              </Col>

              <Col lg={4}>
                <TextField
                  label={<LabelRequired isRequired label="Tên dịch vụ" />}
                  name={"name"}
                  type={"text"}
                  value={formik?.values?.name}
                />
              </Col>

              <Col lg={4}>
                <TextField
                  label={<LabelRequired label="Mô tả" />}
                  name={"description"}
                  type={"text"}
                  value={formik?.values?.description}
                />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="submit"
              className="btn-fill mx-3 spaces min-w-90px btn btn-primary"
            >
              Lưu
            </Button>
            <Button
              variant="btn-fill spaces mx-3 min-w-90px btn btn-secondary"
              onClick={() => handleClose(false)}
            >
              Hủy
            </Button>
          </Modal.Footer>
        </Form>
      </FormikProvider>
    </Modal>
  );
};

export default ServiceDetailDialog;
